import { render, staticRenderFns } from "./customers-status-box.vue?vue&type=template&id=13e0c158&"
import script from "./customers-status-box.vue?vue&type=script&lang=js&"
export * from "./customers-status-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports